import type { PublicSlotKey } from '#packages/apilib';
import type { AddPresetApi } from './addPresetApi';

export const AddPresetApiKey: PublicSlotKey<AddPresetApi> = {
  name: 'AddPresetApi',
  public: true,
};
